module.exports = __webpack_public_path__ + "img/b2b05.5796ef20.png";